import React from 'react';
import { Box } from '@common-fe/common-fe';
import Lottie from 'lottie-react';

import animation from './falling_coins.json';
const InvestmentBannerAnimation = () => {
  return (
    <Box
      data-testid="investment-banner-animation"
      overflow="hidden"
      style={{ position: 'absolute', zIndex: 1, height: '100%', width: '60%' }}
    >
      <Lottie animationData={animation} loop={true} />
    </Box>
  );
};
export default InvestmentBannerAnimation;
